import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import Form from './models/Form';
import Submission from './models/Submission';

// These methods are placed in a standalone file so they can be imported without any typing issue with app.route

export function formulaireFormShow(form: Form) {
    return app.route('formulaireFormShow', {
        id: form.seoId(),
    });
}

export function formulaireFormEdit(form: Form) {
    return app.route('formulaireFormEdit', {
        id: form.id(),
    });
}

export function formulaireSubmissionIndex(form: Form) {
    return app.route('formulaireSubmissionIndex', {
        id: form.id(),
    });
}

export function formulaireSubmission(submission: Submission) {
    // TODO: switch with discussion or user profile for linked forms
    return app.route('formulaireSubmission', {
        id: submission.id(),
    });
}

export function formulaireProfile(user: User, form: Form) {
    return app.route('formulaireProfile', {
        username: user.username(),
        form: form.seoId(),
    });
}
